import { render, staticRenderFns } from "./Distributor.vue?vue&type=template&id=ca899016&scoped=true"
import script from "./Distributor.vue?vue&type=script&lang=js"
export * from "./Distributor.vue?vue&type=script&lang=js"
import style0 from "./Distributor.vue?vue&type=style&index=0&id=ca899016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca899016",
  null
  
)

export default component.exports